import { render, staticRenderFns } from "./fabric.vue?vue&type=template&id=de77cf9e&"
import script from "./fabric.vue?vue&type=script&lang=js&"
export * from "./fabric.vue?vue&type=script&lang=js&"
import style0 from "./fabric.vue?vue&type=style&index=0&lang=less&"
import style1 from "./fabric.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports